"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pubmedCompounds = pubmedCompounds;
const fetchJSON_js_1 = require("./utils/fetchJSON.js");
const includeDBRefs_js_1 = require("./utils/includeDBRefs.js");
/**
 * Retrieve the compounds from a pubmedID
 * @param {string} pubmedID
 * @param {object} [options={}]
 * @param {string} [options.route='pubmeds/v1/id'] - relative URL of the webservice
 * @param {string} [options.baseURL='https://octochemdb.cheminfo.org/'] - URL of the webservice
 * @param {number} [options.limit=1000] - Maximal number of entries to return
 * @returns
 */
async function pubmedCompounds(pubmedID, options = {}) {
    const { route = 'pubmeds/v1/id', baseURL = 'https://octochemdb.cheminfo.org/', limit = 1000, } = options;
    const realURL = new URL(route, baseURL).toString();
    const searchParams = {
        id: pubmedID,
        fields: 'data.compounds',
        limit,
    };
    const { data: results } = await (0, fetchJSON_js_1.fetchJSON)(realURL, searchParams);
    await (0, includeDBRefs_js_1.includeDBRefs)(results, { baseURL });
    return results.data.compounds;
}
//# sourceMappingURL=pubmedCompounds.js.map